import { Button, Col, Flex, Modal, Row, Space } from "antd";
import { useForm } from "antd/es/form/Form";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import SupOtRequestForm from "./SupOtRequestForm";
import SupEditWorkTimeForm from "./SupEditWorkTimeForm";
import SupOffsiteRequestForm from "./SupOffsiteRequestForm";
import SupLeaveRequestForm from "./SupLeaveRequestForm";

const SupervisorRequestOtModal = ({
    isOpen = false,
    onClose = () => { },
    onSubmit = () => { },
    selectedDate = "",
    selectedDateTime = "",
    selectedDateTimeEnd = "",
    selectedEmployee = "",
    selectedOtTime = "",
    selectedOtTimeEnd = "",
    workTypeOptions = [],
    selected = null,
    onAttachFileChange = () => { },
    setpreviousFilew = () => { },
    handleOffSiteModalSubmit = () => { },
    handleLeaveModalSubmit = () => { },
    handleOtModalSubmit = () => { },
    leaveGroupOptions = [],
    editTimeAtt = () => { },
    selectedShift = "",
    employeeName = null
}) => {
    const { t, i18n } = useTranslation();
    const [form] = useForm(null);

    const [selectedForm, setSelectedForm] = useState(selected);

    useEffect(() => {
        if (isOpen && selectedDate) {
            form.setFieldsValue({
                editDate: dayjs(selectedDate)
            });
        }
        if (isOpen && selectedDateTime) {
            form.setFieldsValue({
                startTime: dayjs(selectedDateTime)
            });
        }
        if (isOpen && selectedDateTimeEnd) {

            form.setFieldsValue({
                endTime: dayjs(selectedDateTimeEnd)
            });
        }
        if (isOpen && selectedOtTime) {

            form.setFieldsValue({
                endTime: dayjs(selectedOtTime)
            });
        }
        if (isOpen && selectedOtTimeEnd) {

            form.setFieldsValue({
                endTime: dayjs(selectedOtTimeEnd)
            });
        }
    }, [isOpen, selectedDate, selectedDateTime, selectedDateTimeEnd, form, selectedOtTime, selectedOtTimeEnd]);

    useEffect(() => {
        if (isOpen && selectedDate) {
            form.setFieldsValue({
                startDate: dayjs(selectedDate),
            });
        }
        if (selected) {
            setSelectedForm(selected);
        }
        if (!isOpen) {
            setSelectedForm(null);
        }
    }, [isOpen, selectedDate, form]);

    const renderTitle = useCallback(
        () => {
            return (
                <Flex vertical>
                    {!selectedForm ? (
                        <>
                            <span style={{ fontSize: "18px", color: "#42526D" }}>
                                {i18n.language === "en"
                                    ? dayjs(selectedDate).format("DD/MM/YYYY")
                                    : dayjs(selectedDate).format("DD/MM/BBBB")}
                            </span>
                            <span style={{ fontSize: "14px", fontWeight: "normal" }}>
                                {`${t("shift.header")} ${selectedShift}`}
                            </span>
                        </>
                    ) :
                        (
                            <>
                                <span style={{ fontSize: "18px", color: "#42526D" }}>
                                    {selectedForm === "ot" && (
                                        t("employment-information.label.ot_request")
                                    )}
                                    {selectedForm === "editWork" && (
                                        t("calendar.label.edit_work_hr")
                                    )}
                                    {selectedForm === "leave" && (
                                        t("calendar.label.leave_request")
                                    )}
                                    {selectedForm === "offSite" && (
                                        t("calendar.label.out_site_work_request")
                                    )}
                                </span>
                                <Flex gap={8}>
                                    <span style={{ color: "#667085", fontSize: "14px", fontWeight: "normal" }}>{`${t("employee.label.employee-name")} :`}</span>
                                    <span style={{ color: "#42526D", fontSize: "14px", fontWeight: "normal" }}>{employeeName}</span>
                                </Flex>
                            </>
                        )}
                </Flex>
            );
        },
        [selectedForm, i18n.language, selectedDate, t, selectedShift, employeeName],
    )

    const modal = useCallback(
        () => {
            return <Modal
                title={renderTitle()}
                maskClosable={false}
                open={isOpen}
                footer={false}
                onCancel={onClose}
            >
                {!selectedForm && (
                    <Row gutter={[0, 20]} style={{ marginTop: "24px" }}>
                        <Col span={12} style={{ paddingRight: "16px" }}>
                            <Button
                                style={{
                                    width: "100%",
                                    borderRadius: "5px",
                                    borderColor: "#E4E4E4",
                                    color: "#344054",
                                }}
                                size="large"
                                onClick={() => setSelectedForm("editWork")}
                            >
                                {t("calendar.label.edit_work_hr")}
                            </Button>
                        </Col>
                        <Col span={12} style={{ paddingLeft: "16px" }}>
                            <Button
                                style={{
                                    width: "100%",
                                    borderRadius: "5px",
                                    borderColor: "#E4E4E4",
                                    color: "#344054",
                                }}
                                size="large"
                                onClick={() => setSelectedForm("leave")}
                            >
                                {t("calendar.label.leave_request")}
                            </Button>
                        </Col>
                        <Col span={12} style={{ paddingRight: "16px" }}>
                            <Button
                                style={{
                                    width: "100%",
                                    borderRadius: "5px",
                                    borderColor: "#E4E4E4",
                                    color: "#344054",
                                }}
                                size="large"
                                onClick={() => setSelectedForm("ot")}
                            >
                                {t("employment-information.label.ot_request")}
                            </Button>
                        </Col>
                        <Col span={12} style={{ paddingLeft: "16px" }}>
                            <Button
                                style={{
                                    width: "100%",
                                    borderRadius: "5px",
                                    borderColor: "#E4E4E4",
                                    color: "#344054",
                                }}
                                size="large"
                                onClick={() => setSelectedForm("offSite")}
                            >
                                {t("calendar.label.out_site_work_request")}
                            </Button>
                        </Col>
                    </Row>
                )}
                <Space direction="vertical" style={{ width: "100%", marginTop: "16px" }}>
                    {selectedForm === "editWork" && (
                        <SupEditWorkTimeForm
                            formUse={form}
                            onSubmit={onSubmit}
                            onClose={() => {
                                setSelectedForm(null)
                                if (selected) {
                                    onClose()
                                }
                            }}
                            isOpen={isOpen}
                            selectedDate={selectedDate}
                            selectedDateTime={selectedDateTime}
                            selectedDateTimeEnd={selectedDateTimeEnd}
                        />
                    )}

                    {selectedForm === "leave" && (
                        <SupLeaveRequestForm
                            isOpen={isOpen}
                            onClose={() => {
                                setSelectedForm(null)
                                if (selected) {
                                    onClose()
                                }
                            }}
                            selectedDate={selectedDate}
                            leaveGroupOptions={leaveGroupOptions}
                            onAttachFileChange={onAttachFileChange}
                            setpreviousFilew={setpreviousFilew}
                            handleLeaveModalSubmit={handleLeaveModalSubmit}
                        />
                    )}

                    {selectedForm === "ot" && (
                        <SupOtRequestForm
                            isOpen={isOpen}
                            onClose={() => {
                                setSelectedForm(null)
                                if (selected) {
                                    onClose()
                                }
                            }}
                            onSubmit={handleOtModalSubmit}
                            selectedDate={selectedDate}
                            selectedEmployee={selectedEmployee}
                            onAttachFileChange={onAttachFileChange}
                            setpreviousFilew={setpreviousFilew}
                            selectedOtTime={selectedOtTime}
                            selectedOtTimeEnd={selectedOtTimeEnd}
                        />
                    )}

                    {selectedForm === "offSite" && (
                        <SupOffsiteRequestForm
                            isOpen={isOpen}
                            onClose={() => {
                                setSelectedForm(null)
                                if (selected) {
                                    onClose()
                                }
                            }}
                            workTypeOptions={workTypeOptions}
                            onAttachFileChange={onAttachFileChange}
                            setpreviousFilew={setpreviousFilew}
                            handleOffSiteModalSubmit={handleOffSiteModalSubmit}
                            selectedDate={selectedDate}
                        />
                    )}
                </Space>
            </Modal>
        },
        [selectedForm,
            selectedDate,
            selectedDateTime,
            selectedDateTimeEnd,
            renderTitle,
            isOpen,
            onSubmit],
    )

    return (
        modal()
    );
};

export default SupervisorRequestOtModal;
